import { util } from '@citation-js/core';
import parseDoiJson from './json.js';
const apiOptions = {
  checkContentType: true,
  headers: {
    Accept: 'application/vnd.citationstyles.csl+json'
  }
};
async function fetchDoiApiAsync(url) {
  const result = await util.fetchFileAsync(url, apiOptions);
  return result === '[]' ? {} : JSON.parse(result);
}
async function parseDoiApiAsync(data) {
  const doiJsonList = await Promise.all([].concat(data).map(fetchDoiApiAsync));
  return doiJsonList.map(parseDoiJson);
}
function fetchDoiApi(url) {
  const result = util.fetchFile(url, apiOptions);
  return result === '[]' ? {} : JSON.parse(result);
}
function parseDoiApi(data) {
  return [].concat(data).map(fetchDoiApi).map(parseDoiJson);
}
export { parseDoiApi as parse, parseDoiApiAsync as parseAsync };